<template>
	<div class="main-contents">
		<div class="contents">
			<div class="contents_body">
				<div :class="registerFlag == 'create'?'tit':'tit tit_margin'">
					<span v-if="registerFlag == 'create'">정보입력</span>
					<span v-if="registerFlag == 'update'">내 계정 관리</span>
				</div>

				<div class="joinbox">
					<div>
						<div class="Area">
							<div class="Item">
								<table class="tb">
									<tbody>
										<tr>
											<th>
												<span>*</span>
												<label for="txt01"><nbsp/>성명</label>
											</th>
											<td colspan="2">
											<InputComp v-model="mberInfo.mberNm" :readonly="!this.forwardData.pass" maxlength="50" title="성명" :inputable="inputable.name" :rules="{'required':true}" />
											</td>
										</tr>
										<tr>
											<th>
												<span>*</span>
												<label for="txt02"><nbsp/>회원아이디</label>
											</th>
											<td colspan="2">
												<InputComp v-model="mberInfo.id" :classNm="registerFlag == 'create' ? 'mem_id' : ''" :readonly="registerFlag != 'create'" maxlength="16" @input="temp.idDupChkPass = false" title="아이디"  :rules="{'required':true, 'minLength':4, 'maxLength':16}" placeholder="4~16자의 영문 소문자, 숫자만 사용가능 합니다"/>
												<nbsp/><div class="check-btn" @click="dupChk()" v-if="registerFlag == 'create'">아이디 중복확인</div>
											</td>
										</tr>
										<tr>
											<th>
												<span>*</span>
												<label for="psw01"><nbsp/>비밀번호</label>
											</th>
											<td colspan="2">
												<InputComp type="password" v-model="mberInfo.password" maxlength="16" title="비밀번호" :rules="{'required':temp.pwdReq, 'minLength':8, 'maxLength':16}" placeholder="8~16자의 영문, 숫자, 특수문자를 모두 사용하세요"/>
											</td>
										</tr>
										<tr>
											<th>
												<span>*</span>
												<label for="psw02"><nbsp/>비밀번호 확인</label>
											</th>
											<td colspan="2">
												<InputComp type="password" v-model="mberInfo.passwordCfm" maxlength="16" title="비밀번호 확인" :rules="{'required':temp.pwdReq,'minLength':8,'maxLength':16,'func' : {rule:same, args:mberInfo.password}}"/>
											</td>
										</tr>
										<tr>
											<th>
												<span>*</span>
												<label for="hpNo"><nbsp/>휴대폰번호</label>
											</th>
											<td colspan="2">
												<InputComp type="cell"  v-model="mberInfo.hpNo" :classNm="registerFlag == 'update' ? 'mem_id' : ''" title="휴대폰번호" :rules="{'required':true}" :readonly="!this.forwardData.pass"/>
												<nbsp/><div class="check-btn" style="text-align: center;" @click="nameCng('hp')" v-if="registerFlag == 'update'">번호 변경하기</div>
											</td>
										</tr>
										<tr>
											<th>
												<span>*</span>
												<label for="txt04"><nbsp/>이메일</label>
											</th>
											<td colspan="2" class="email">
												<InputComp v-model="temp.emailId" classNm="mem_id certi" @input="emailDataInit();" title="이메일" maxlength="30" :inputalbe="inputable.email" :rules="{'required':true}" :showError="false" /> &commat; <InputComp classNm="mem_id certi" v-model="temp.domainTxt" @input="emailDataInit();" maxlength="15" :readonly="temp.domainSlt == '' ? false : true" title="도메인" :inputalbe="inputable.domain" :rules="{'required':true}" :showError="false"/>
												<nbsp/>
												<div class="select_wrap" @change="temp.domainTxt = temp.domainSlt; emailDataInit();">
													<select v-model="temp.domainSlt">
														<option value="" selected>직접입력</option>
														<option :value="domain" v-for="domain in emailDomaiList" :key="domain">{{domain}}</option>
													</select>
												</div>
												<nbsp/><div class="check-btn certi" @click="sendEmail()">이메일 인증하기</div>
												<div v-show="temp.inputCertShow">
													<InputComp classNm="mem_id" placeholder="인증번호를 입력해주세요" v-model="temp.inputCertTxt" />
													<nbsp/><div class="check-btn" style="text-align: center;" @click="emailCert()">확인</div>
												</div>
											</td>
										</tr>
										<tr v-if="mberInfo.mberSeq">
											<th>
												<label for="txt05"><nbsp/>광고성 정보 수신동의</label>
											</th>
											<td colspan="2">
												<input type="checkbox" v-model="mberInfo.emailYn" @click="clickSms('email')">
												<label @click="clickSms('email')">
													<span class="rd"></span>
													이메일
												</label>
												<nbsp />
												<input type="checkbox" v-model="mberInfo.smsYn" @click="clickSms('sms')">
												<label @click="clickSms('sms')">
													<span class="rd"></span>
													문자메세지
												</label>
											</td>
										</tr>

										<tr v-if="mberInfo.mberDivCd == '11'">
											<th>
												<span>*</span>
												<label for="txt09"><nbsp/>생년월일</label>
											</th>
											<td colspan="2">
												<InputComp type="date" classNm="birth" v-model="mberInfo.birthYyyymmdd" title="입력 예) 20020101" format="yyyy년 MM월 dd일" :readonly="!this.forwardData.pass"/>
											</td>
										</tr>

										<tr v-if="mberInfo.mberDivCd == '11'">
											<th>
												<span>*</span>
												<label for="txt10"><nbsp/>성별</label>
											</th>
											<td colspan="2">
												<SelectComp type="radio" list="F:여,M:남" v-model="mberInfo.gender" defValue="F" :disabled="!this.forwardData.pass"/>
											</td>
										</tr>

										<tr v-if="'21, 22, 31'.indexOf(mberInfo.mberDivCd) > -1">
											<th>
												<span>*</span>
												<label for="txt12"><nbsp/>회사명</label>
											</th>
											<td colspan="2">
												<AutoComplete type="text" class="company" v-model="temp.corpInfo" :list="corpList" listText="corpNm" @autoComplete="setCorpInfo" v-if="'21, 22'.indexOf(mberInfo.mberDivCd) > -1" :readonly="registerFlag != 'create'"  title="회사명" :rules="{'required':temp.demCorpReq}">
													<template v-slot:autoComplete="autoComplete">{{autoComplete.item.corpNm}} / {{autoComplete.item.bizRegNo}}</template>
												</AutoComplete>
												<AutoComplete type="text" class="company" v-model="temp.corpInfo" :list="corpList" listText="corpNm" @autoComplete="setCorpInfo" v-if="'31'.indexOf(mberInfo.mberDivCd) > -1" :readonly="registerFlag != 'create'"  title="회사명" :rules="{'required':true}">
													<template v-slot:autoComplete="autoComplete">{{autoComplete.item.corpNm}} / {{autoComplete.item.bizRegNo}}</template>
												</AutoComplete>
											</td>
										</tr>

										<tr v-if="mberInfo.mberDivCd == '22'">
											<th>
												<span>*</span>
												<label for="txt13"><nbsp/>부서명</label>
											</th>
											<td colspan="2">
												<InputComp classNm="department" v-model="mberInfo.deptNm" title="부서명" :rules="{'required':true}"/>
												<span class="rank">*</span>
												<label for="txt14" class="rank"><nbsp/>직급</label>
												<nbsp/><nbsp/>
												<InputComp classNm="rank" v-model="mberInfo.positionNm" title="직급" :rules="{'required':true}"/>
											</td>
										</tr>										

										<tr v-if="mberInfo.mberDivCd == '11' && !mberInfo.mberSeq">
											<th>
												<!-- <span>*</span> -->
												<label for="txt10"><nbsp/>추천인 연락처</label>
											</th>
											<td colspan="2">
												<InputComp type="cell" v-model="mberInfo.recmmderHpNo" placeholder="- 를 제외한 숫자만 입력해 주세요." />
											</td>
										</tr>

									</tbody>
								</table>
								<!-- 취소/완료 버튼 -->
								<div class="agree-btn" :class="registerFlag == 'update' ? 'control' : ''">
									<div :class="registerFlag == 'create' ? 'btn-cancel' : 'btn'" @click="btnCancel()">취소</div>
									<div class="btn-complete" @click="btnSubmit()" v-if="registerFlag == 'create'">확인</div>
									<div class="btn-complete" @click="btnSubmit()" v-if="registerFlag == 'update'">회원정보 변경</div>
									<div class="btn-withdraw" @click="btnWithdrawal()" v-if="registerFlag == 'update'">회원탈퇴</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { signupInfoMeta } from '@/utils/meta';
import { updateInfoMeta } from '@/utils/meta';
import ChannelService from '@/utils/channel';

export default {
	metaInfo() {
		return this.metaData;
	},
	data() {
		return {
			registerFlag : 'create',
			pageType:'cham',
			
			// 회원정보
			mberInfo : {
				id : '',
				password : '',
				passwordCfm : '',
				emailYn : true,
				smsYn : true,
				corpSeq : '',
				bizRegNo : '',
				email : '',
				mberDivCd : '',
				indtypeClassCd : '',

				// 회원소속사 변경 관리
				// preCorpSeq : '',
				// aftCorpSeq : '',
				mberCorpDiv: '',
				//classDivCd : '',
				//apprCorpList : []

				recmmderHpNo: '',
			},

			// 임시
			temp : {
				mberDiv : '',
				mberCorpDiv : '1',
				corpInfo : '',
				inputCertShow : false,
				pwdReq : true,
				emailId : '',
				domainSlt : '',
				domainTxt : '',
				idDupPass : true,
				emailPass : true,
				tecCorpReq : false,
			},

			// oriMberCorpDiv: '',
			// oriCorpInfo: '',
			
			
			corpList : [],
			userInfo : {},
			kcpcert : {},
			forwardData : {},

			inputable : {
				name : ["han"],
				id : ["lowr", "num"], /* id : ["lowr", "uppr","num"], - > lowr, num */
				email : "A-Za-z_.",
				domain : "a-z.",
				birth : ["num"]
			},

			// 이메일 selectBox
			emailDomaiList : ['naver.com', 'gmail.com', 'daum.net', 'nate.com', 'empas.com'],
			metaData : signupInfoMeta,
		}
	},

	beforeMount() {
		var viewNm = this.$route.name;
	
		if(viewNm == 'MEM004M03') { // 회원가입 정보입력 시
			this.forwardData = this.$route.params.secrets;

			if(this.forwardData) {
				this.setMberInfo();
				
				if('21, 22'.indexOf(this.mberInfo.mberDivCd) > -1) {
					this.corpSearch('10');
				}else if('31'.indexOf(this.mberInfo.mberDivCd) > -1){
					this.corpSearch('20');
				}
			}else {
				this.$router.replace({name : 'MEM003M01'});
			}
		}else { // 회원정보 변경시
			this.registerFlag = 'update';
			this.temp.pwdReq = false;
			this.metaData = updateInfoMeta;
			if(viewNm == 'MYP102M01') {
				this.pageType = '';
				//this.corpSearch('20');
			}else if('MYP202M01, MYP302M01'.indexOf(viewNm) > -1) {
				this.corpSearch('10');
			}

			this.selectMberInfo();
		}

		//this.getCommonCode();
		
	},

	methods : {
		// 영문소문자 , 숫자 입력 체크
		// valueCheck(e) {
		// 	if (e.getModifierState("CapsLock")) {
		// 		alert("CapsLock이 켜져있습니다.")
		// 	}
		// },
		setMberInfo() {
			this.mberInfo.mberDivCd = this.forwardData.mberDivCd;
			this.mberInfo.title = this.forwardData.title;
			this.mberInfo.stipList = this.forwardData.stipList;

			// 본인인증 data
			if(this.forwardData.kcpcert) {
				this.mberInfo.hpNo = this.forwardData.kcpcert.phone_no;
				this.mberInfo.mberNm = this.forwardData.kcpcert.user_name;
				this.mberInfo.birthYyyymmdd = this.forwardData.kcpcert.birth_day;
				this.mberInfo.gender = this.forwardData.kcpcert.sex_code == '01' ? 'M' : 'F';
				this.mberInfo.authCi = this.forwardData.kcpcert.ci;
				this.mberInfo.authDi = this.forwardData.kcpcert.di;
				this.mberInfo.up_hash = this.forwardData.kcpcert.up_hash;
			}

		},
		
		  

		// 아이디/이메일 중복체크
		dupChk() {
			if(!this.mberInfo.id) {
				alert("아이디를 입력하세요.");
				return false;
			}

			//비밀번호 형식 체크
			var idCheck = this.idChk();
			if(!idCheck) return;
			
			this.$.httpPost('/api/mem/chkDup', {id : this.mberInfo.id}, '')
				.then(res => {
					if(res.data.resultCode == '000') {
						if(res.data.data.dupChk == 0) {
							alert('사용가능한 아이디 입니다.');
							this.temp.idDupChkPass = true;
						}else {
							alert('이미 사용중인 아이디 입니다.');
							this.temp.idDupChkPass = false;
						}
					}
				});
		},

		emailMake() {
			this.mberInfo.email = this.temp.emailId + '@' + this.temp.domainTxt;
		},

		sendEmail() {
			if(!this.temp.emailId || !this.temp.domainTxt) {
				alert("이메일을 입력하세요.");
				return false;
			}

			if(this.temp.inputCertTxt) {
				this.emailDataInit();
			}

			var param = {};
			param.email = this.temp.emailId + '@' + this.temp.domainTxt;
			if(this.forwardData.pass) param.pass = this.forwardData.pass;

			this.$.httpPost('/api/mem/sendEmailCert', param)
				.then(rs => {
					if(rs.data.resultCode == '000') {
						this.temp.inputCertShow = true; 
						this.temp.emailHash = rs.data.emailHash;
					}
				})	
		},

		// 이메일 인증
		emailCert() {
			var param = {}
			param.email = this.temp.emailId + '@' + this.temp.domainTxt;
			param.emailHash = this.temp.emailHash;
			param.inputCertTxt = this.temp.inputCertTxt;

			this.$.httpPost('/api/mem/emailCertChk', param, '')
				.then(res => {
					if(res.data.resultCode == '000') {
						if(res.data.certRs == 'pass') {
							this.temp.inputCertShow = false;
							this.temp.emailCertPass = true;
							alert('이메일 인증 완료');
						}else {
							this.temp.emailCertPass = false;
							alert('인증번호가 일치하지 않습니다.');
						}
					}

					// this.$forceUpdate();
				});
		},

		// 이메일 인증 초기화
		emailDataInit() {
			if(this.temp.emailCertPass) {
				this.temp.inputCertTxt = '';
				this.temp.inputCertShow = false;
				this.temp.emailCertPass = false;
				this.temp.emailHash = '';
			}

			// 회원정보 수정시 이메일 인증처리
			if(this.temp.email && this.temp.emailId + '@' + this.temp.domainTxt == this.temp.email) {
				this.temp.emailCertPass = true;
			}
		},

		// 기업조회
		corpSearch(div) {
			this.$.httpPost('/api/mem/searchCorp', {corpDivCd : div, pageType : this.pageType}, '')
				.then(res => {
					if(res.data.resultCode == '000') {
						this.corpList = res.data.corpList;
					}
				});
		}, // corpSearch

		// 고객사/제휴사 선택
		setCorpInfo(corpInfo) {
			if(corpInfo) {
				this.temp.corpSeq = corpInfo.corpSeq;
				this.temp.corpNm = corpInfo.corpNm;
				this.temp.bizRegNo = corpInfo.bizRegNo;

				this.mberInfo.corpSeq = corpInfo.corpSeq;
				this.mberInfo.corpNm = corpInfo.corpNm;
				this.mberInfo.bizRegNo = corpInfo.bizRegNo;
			}else {
				this.mberInfo.corpSeq = '';
				this.mberInfo.corpNm = '';
				this.mberInfo.bizRegNo = '';
			}
		},

		// 비밀번호/비밀번호확인 일치 체크
		same(val, args){
			return val == (args || '') || '비밀번호와 일치하지 않습니다.';
		},
		
		idChk() {
			const idTest = /^[a-z0-9]{4,16}$/;
			var idRes = idTest.test(this.mberInfo.id);

			if(idRes) {
				return true;
			} else {
				alert("아이디는 4~16자의 영문 소문자, 숫자를 사용해야 합니다.");
				return false;
			}
		},

		// 비밀번호 형식 체크
		passChk() {
			const passTest = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[`~!@#$%^&*()_+=-]).{8,16}$/;
			var passRes = passTest.test(this.mberInfo.password);

			if(passRes) {
				return true;
			} else {
				alert("비밀번호는 8~16자의 영문, 숫자, 특수문자를 모두 사용해야 합니다.");
				return false;
			}
			
		},

		// 회원소속사 변경시
		mberCorpDivCng() {
			this.mberInfo.corpSeq = '';
			this.mberInfo.corpNm = '';
			this.mberInfo.bizRegNo = '';
			this.temp.corpInfo = '';

			if(this.temp.mberCorpDiv == '1') this.mberInfo.corpSeq = '1';
			
			if(this.temp.mberCorpDiv == '2' && this.temp.corpSeq) {
				this.mberInfo.corpSeq = this.temp.corpSeq;
				this.mberInfo.corpNm = this.temp.corpNm;
				this.mberInfo.bizRegNo = this.temp.bizRegNo;
			}

			if(this.temp.mberCorpDiv == '3') {
				this.mberInfo.empDivCd = '02';
			}
		},

		// 주소검색
		jusoPop() {
			this.$.jusoSearch(this, function(this_obj, res) {
				this_obj.mberInfo.corpZipCd 	= res.zipNo;
				this_obj.mberInfo.corpAddr		= res.roadAddrPart1;
				this_obj.mberInfo.corpAddrDtl 	= res.addrDetail + " " + res.roadAddrPart2;
				this_obj.$forceUpdate();
			});
		},

		// 조회
		selectMberInfo() {
			this.userInfo = this.$store.state.userInfo;
			this.$.httpPost('/api/mem/selectMberInfo', this.userInfo, '')
				.then(res => {
					if(res.data.resultCode == '000') {
						this.mberInfo = res.data.mberInfo;
						
						// 라디오 버튼 -> 체크박스 변경으로 인한 데이터 변경
						if(this.mberInfo.emailYn == 'Y') {
							this.mberInfo.emailYn = true;
						} else {
							this.mberInfo.emailYn = false;
						}

						if(this.mberInfo.smsYn == 'Y') {
							this.mberInfo.smsYn = true;
						} else {
							this.mberInfo.smsYn = false;
						}

						this.temp.mberCorpDiv = res.data.mberInfo.mberCorpDiv;
						this.temp.corpInfo = res.data.mberInfo.corpNm;
						this.temp.email = res.data.mberInfo.email;
						this.temp.emailCertPass = true;
						this.temp.emailId = res.data.mberInfo.emailId;
						this.temp.domainTxt = res.data.mberInfo.domain;

						for(var i in this.emailDomaiList) {
							if(this.emailDomaiList[i] == res.data.mberInfo.domain) this.temp.domainSlt = res.data.mberInfo.domain;
						}

						if(this.mberInfo.mberDivCd == '11') {
							this.mberInfo.title = '개인정보 관리';
						}else {
							this.mberInfo.title = '정보관리';
						}
					}
				})
				.catch(() => {
					//console.log(err.message);
				})
		},

		// 본인인증
		nameCng(div) {
			this.$.kcpCert(this, function(this_obj, res) {
				this_obj.kcpcert = res;
				this_obj.mberchk(div);
			});			
		},

		mberchk(div) {
			var param = {
				di : this.kcpcert.di,
				ci : this.kcpcert.ci,
				mberDivCd : this.mberInfo.mberDivCd
			};

			this.$.httpPost('/api/mem/memberChk', param,'')
				.then((res) => {
					//console.log('memberChk res', res);

					if(res.data.resultCode == '000') {
						if(res.data.idMap && div == 'name') {
							alert('이미 등록된 회원입니다.');
							return false;
						}else if(!res.data.idMap && div == 'hp') {
							alert("생성시 등록한 휴대폰 명의와 일치하지 않습니다.");
							return false;
						}else {
							this.mberInfo.hpNo = this.kcpcert.phone_no;
							this.mberInfo.mberNm = this.kcpcert.user_name;
							this.mberInfo.birthYyyymmdd = this.kcpcert.birth_day;
							this.mberInfo.gender = this.kcpcert.sex_code == '01' ? 'M' : 'F';
							this.mberInfo.authCi = this.kcpcert.ci;
							this.mberInfo.authDi = this.kcpcert.di;
							this.mberInfo.up_hash = this.kcpcert.up_hash;
						}
					}
				})
		},

		// 입력값 검사
		inputValidate() {
			if(this.mberInfo.id instanceof Error) {
				alert('아이디를 입력하지 않았습니다.');
				return false;
			}

			if(this.registerFlag == 'create') {
				if(!(this.mberInfo.id instanceof Error) && !this.temp.idDupChkPass) {
					alert('아이디 중복체크가 완료되지 않았습니다.');
					return false;
				}
			}

			if(this.mberInfo.password instanceof Error) {
				alert('비밀번호를 입력하지 않았습니다.');
				return false;
			}

			if(this.mberInfo.passwordCfm instanceof Error) {
				alert('비밀번호 확인을 체크해주세요.');
				return false;
			}

			if(!this.temp.emailCertPass) {
				alert('이메일 인증이 완료되지 않았습니다.');
				return false;
			}

			if(this.mberInfo.mberDivCd != '11' && this.temp.corpInfo == '') {
				alert('회사명을 선택하지 않았습니다.');
				return false;
			}

			return true;
		},

		// 만 19세 이상 확인
		ageChk() {
			var ageRes = true;
			
			if(this.mberInfo.birthYyyymmdd && this.mberInfo.mberDivCd == '11') {
				var date = new Date();
				var year = date.getFullYear();
				var month = (date.getMonth() + 1);
				var day = date.getDate();
				
				if (month < 10) month = '0' + month;
				if (day < 10) day = '0' + day;
				
				var monthDay = month + day;
				var birth = this.mberInfo.birthYyyymmdd;
				
				var birthdayy = birth.substr(0, 4);
				var birthdaymd = birth.substr(4, 4);
				var age = monthDay < birthdaymd ? year - birthdayy - 1 : year - birthdayy;

				if(age < 19) {
					alert("만 19세 미만은 회원가입을 하실 수 없습니다. ");
					ageRes = false;
				}
			}

			return ageRes;
		},

		// 등록/변경
		btnSubmit() {
			// validation
			var val = this.inputValidate();
			if(!val) return;

			// 나이 체크
			val = this.ageChk();
			if(!val) return;

			//비밀번호 형식 체크
			val = this.passChk();
			if(!val) return;

			this.sendData();
		},

		sendData() {
			var url = 'insertMberInfo';
			if(this.registerFlag == 'update') url = 'updateMberInfo';

			if(this.temp.inputCertTxt) this.mberInfo.inputCertTxt = this.temp.inputCertTxt;
			if(this.temp.emailHash) this.mberInfo.emailHash = this.temp.emailHash;
			this.mberInfo.email = this.temp.emailId + '@' + this.temp.domainTxt;

			// 라디오 버튼 -> 체크박스 변경으로 인한 데이터 변경
			if(this.mberInfo.emailYn) {
				this.mberInfo.emailYn = 'Y'
			} else {
				this.mberInfo.emailYn = 'N'
			}

			if(this.mberInfo.smsYn) {
				this.mberInfo.smsYn = 'Y'
			} else {
				this.mberInfo.smsYn = 'N'
			}

			var param = {};
			param.mberInfo = this.mberInfo;
			
			this.$.httpPost('/api/mem/' + url, param, '')
				.then(res => {
					if(res.data.resultCode == "000"){
						if(this.registerFlag == 'create') {
							//var sendData = { mberSeq : res.data.data.mberSeq };

							this.$router.push({name : 'MEM004M04', params : {forwardData : this.mberInfo.title}});
						}else {
							if(this.$store.state.profile.name == "운영") {
								ChannelService.updateUser({
									"pluginKey": "046ab1d1-fc22-44f8-991e-b9a70e41aceb", // fill your plugin key
									"memberId": this.mberInfo.mberSeq, // fill user's member id
									"profile": { // fill user's profile
										"name" : this.mberInfo.mberNm,
										"email": this.mberInfo.email, // fill user's name
										"mobileNumber": this.mberInfo.hpNo,
										"mberDiv" : this.mberInfo.mberDivCd == '11' ? "IT프로" : this.mberInfo.mberDivCd == '22' ? "클라이언트" : "파트너사",
									},
									"unsubscribeEmail" : this.mberInfo.emailYn == 'Y' ? false : true, // 이메일 수신 거부
									"unsubscribeTexting" : this.mberInfo.smsYn == 'Y' ? false : true, // 문자 수신 거부
								});
							}
							alert('정보가 변경되었습니다.');
							//this.$router.push(this.$route.name);
							//this.$router.go();
							this.$router.push('/');
	
						}
					}else {
						alert(res.data.message);
					}
				})
				.catch(err => {
					alert(err.response.data.error_description);
				});
		},

		btnCancel() {
			if(this.registerFlag == 'create') {
				this.$router.replace({name : 'MEM003M01'});
			}else {
				this.$router.go(-1);
			}
		},

		btnWithdrawal() {
			var param = {};
			param.mberSeq = this.mberInfo.mberSeq;
			param.id = this.mberInfo.id;

			this.$.popup('/tec/myp/MYP102P01', param)
				.then(res => {
					if(res) {
						if(this.$store.state.profile.name == "운영") {
							ChannelService.updateUser({
								"pluginKey": "046ab1d1-fc22-44f8-991e-b9a70e41aceb", // fill your plugin key
								"memberId": this.mberInfo.mberSeq, // fill user's member id
								"profile": { // fill user's profile
									"name" : this.mberInfo.mberNm + "-탈퇴",
								},
								"unsubscribeEmail" : true, // 이메일 수신 거부
								"unsubscribeTexting" : true, // 문자 수신 거부
							});
							// this.$.logout('MEM005M01');
						}
						this.$.logout('MEM005M01');
					}
				});

			// if(confirm('회원탈퇴 하시겠습니까?')) {
			// 	this.$.httpPost('/api/mem/memberWithdrawal')
			// 	.then(() => {
			// 		alert('회원탈퇴 되었습니다.');
			// 		this.$.logout();
			// 	})
			// }
		},

		clickSms(name) {
			if(name == 'email') {
				if(!this.mberInfo.emailYn) {					
					this.mberInfo.emailYn = false;
				} else {
					this.mberInfo.emailYn = true;
				}
			} else if (name == 'sms') {
				if(this.mberInfo.smsYn) {
					this.mberInfo.smsYn = false;
				} else {
					this.mberInfo.smsYn = true;
				}
			}	
		}
		
	}
}

</script>

<style>

</style>